/*
 * Enables click-and-drag ("swipe") navigation with the mouse on the
 * homepage slideshow. Touch devices keep using native scroll/snap.
 */
(function () {
  var DRAG_THRESHOLD = 5; // px before a movement counts as a drag

  function initSwipe(slider) {
    if (!slider || slider.dataset.swipeInit === 'true') return;
    slider.dataset.swipeInit = 'true';

    var isDown = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    function firstSlide() {
      return slider.querySelector('.slideshow__slide, .slider__slide');
    }

    slider.addEventListener('pointerdown', function (e) {
      // Only take over for mouse; touch/pen keep native scrolling.
      if (e.pointerType !== 'mouse') return;
      // Do not initiate drag if clicking on interactive elements (links, buttons, controls)
      if (e.target && e.target.closest('a, button, .button, .slider-button, .slideshow__control-wrapper, .slideshow__controls')) return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScroll = slider.scrollLeft;
      slider.classList.add('slideshow--dragging');
    });

    window.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > DRAG_THRESHOLD) moved = true;
      slider.scrollLeft = startScroll - dx;
    });

    function end() {
      if (!isDown) return;
      isDown = false;
      slider.classList.remove('slideshow--dragging');
      if (!moved) return;

      // Snap to the nearest slide once the drag is released.
      var slide = firstSlide();
      if (slide && slide.clientWidth) {
        var width = slide.clientWidth;
        var target = Math.round(slider.scrollLeft / width) * width;
        slider.scrollTo({ left: target, behavior: 'smooth' });
      }
    }

    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);

    // Swallow the click that follows a drag so links/buttons don't fire.
    slider.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );

    // Avoid the browser's native image drag while swiping.
    slider.addEventListener('dragstart', function (e) {
      if (e.target && e.target.tagName === 'IMG') e.preventDefault();
    });
  }

  function init() {
    document
      .querySelectorAll('slideshow-component [id^="Slider-"]')
      .forEach(initSwipe);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
